const parseSessionStorageVariable = (name) => {
  const value = sessionStorage.getItem(name);

  // Gérer les cas de valeurs nulles ou indéfinies au début
  if (value === null || value === undefined) {
    return null;
  }

  // Gérer les chaînes primitives (null, true, false, 0, "")
  switch (value) {
    case 'null':
      return null;
    case 'true':
      return true;
    case 'false':
      return false;
    case '0':
      return 0;
    case '""':
      return '';
  }

  if (
    value.startsWith('{') ||
    value.startsWith('[') ||
    value.startsWith('"') ||
    !isNaN(value)
  ) {
    try {
      const jsonObject = JSON.parse(value);
      return jsonObject;
    } catch {
      return value;
    }
  }

  return value;
};

export default parseSessionStorageVariable;
